<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between">
  <div class="flex justify-content-start flex-wrap mb-2">
    <div *ngIf="permissions.insectaryApproveOrders" class="flex align-items-center justify-content-center mr-1">
      <p-button
        styleClass="action-btn"
        label="Approve Orders"
        [raised]="true"
        iconPos="right"
        [badge]="approvalCount"
        (onClick)="approveOrder()"></p-button>
    </div>
    <div *ngIf="permissions.insectaryVendorOrders" class="flex align-items-center justify-content-center mr-1">
      <p-button styleClass="action-btn" label="Vendor Orders" [raised]="true" iconPos="right" (onClick)="vendorOrders()"></p-button>
    </div>
    <div *ngIf="permissions.insectaryInsectPrep" class="flex align-items-center justify-content-center mr-1">
      <p-button styleClass="action-btn" label="Insect Prep" [raised]="true" iconPos="right" (onClick)="insectPrep()"></p-button>
    </div>
    <div *ngIf="permissions.insectarySubstratePrep" class="flex align-items-center justify-content-center mr-1">
      <p-button styleClass="action-btn" label="Media Prep" [raised]="true" iconPos="right" (onClick)="substratePrep()"></p-button>
    </div>
  </div>
  <div class="flex justify-content-end">
    <label class="mr-2">Show All</label>
    <p-toggleswitch [(ngModel)]="showAll" (change)="toggleShowAll()" data-testid="showAllToggle" />
  </div>
</div>
<div class="flex align-items-center justify-content-center">
  <p-button pTooltip="Reset Table" tooltipPosition="top" icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)"></p-button>
  <p-button
    pTooltip="Clear Filter/Sort"
    tooltipPosition="top"
    *ngIf="filtersActive"
    icon="pi pi-filter-slash"
    [raised]="true"
    (click)="clearFilters(dt)"></p-button>
</div>
<div class="mt-1 mb-1">
  <p-accordion value="0">
    <p-accordion-panel value="4">
      <p-accordion-header>Orders Calendar</p-accordion-header>
      <p-accordion-content>
        <app-insectary-calendar
          #insectaryCalendar
          [siteName]="siteName"
          [showAll]="showAll"
          [undeliverableDates]="pageVars.undeliveravbleDates"
          [undeliverableDays]="pageVars.undeliveravbleDays"
          (calendarReady)="onCalendarReady()">
        </app-insectary-calendar>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
<p-table
  #dt
  [value]="orders"
  [columns]="cols"
  [paginator]="true"
  [reorderableColumns]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [first]="skip"
  [rows]="take"
  [totalRecords]="totalCount"
  [filterDelay]="300"
  [lazy]="true"
  stateStorage="local"
  stateKey="insectary-dashboard-table"
  (onLazyLoad)="handleTableEvents($event)"
  [scrollable]="true"
  [scrollHeight]="'60vh'">
  <ng-template #header let-columns>
    <tr>
      <th
        *ngFor="let col of columns"
        pResizableColumn
        pReorderableColumn
        [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)"
        nowrap>
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
          [matchModeOptions]="
            col.type === 'text'
              ? customMatchModeOptions
              : col.type === 'date'
                ? dateMatchModeOptions
                : col.type === 'numeric'
                  ? numericMatchModeOptions
                  : undefined
          ">
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-order let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'insectary']">
            {{ order[col.field] }}
          </a>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ order[col.field] }}
          </div>
          <ng-container *ngSwitchDefault>
            {{ order[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length">No orders found.</td>
    </tr>
  </ng-template>
</p-table>
